module.exports = __webpack_public_path__ + "static/media/23.0880bfb6.jpg";